import React from 'react';

import Header from '../components/Header';
import HeroComponent from "../components/HeroComponent.js";
import FooterComponent from "../components/FooterComponent.js";
import ScreenshotCarousel from "../components/ScreenshotCarousel.js";

const features = [
  {
    title: "Swipe to Match",
    description: "Build your profile with your favorite games, platform, and play style. Then swipe to find players who fit your vibe."
  },
  {
    title: "In-App Chat",
    description: "No app-hopping. Once matched, chat directly and coordinate your next gaming session without leaving Beanbag."
  },
  {
    title: "Find Your Vibe",
    description: "Whether you're casual, competitive, or somewhere in between — find teammates who actually match how you play."
  }
];

const availableGames = [
  { name: "Apex Legends", short: "APEX", logo: "/logos/apex.png" },
  { name: "Arc Raiders", short: "ARC", logo: "/logos/arc.png" },
  { name: "Call of Duty: Warzone", short: "WZ", logo: "/logos/wz.png" },
  { name: "CS2", short: "CS2", logo: "/logos/cs2.png" },
  { name: "Dead by Daylight", short: "DBD", logo: "/logos/dbd.png" },
  { name: "Deadlock", short: "DL", logo: "/logos/dl.png" },
  { name: "Dota 2", short: "D2", logo: "/logos/d2.png" },
  { name: "EA Sports FIFA", short: "FIFA", logo: "/logos/fifa.png" },
  { name: "Fortnite", short: "FN", logo: "/logos/fn.png" },
  { name: "League of Legends", short: "LoL", logo: "/logos/lol.png" },
  { name: "Marvel Rivals", short: "MR", logo: "/logos/mr.png" },
  { name: "Overwatch", short: "OW", logo: "/logos/ow.png" },
  { name: "PUBG", short: "PUBG", logo: "/logos/pubg.png" },
  { name: "Rainbow Six Siege", short: "R6S", logo: "/logos/r6s.png" },
  { name: "Rust", short: "RUST", logo: "/logos/rust.png" },
  { name: "Valorant", short: "VAL", logo: "/logos/val.png" },
];

const Home = () => {
  return (
    <div className='relative'>
        <Header />     
        <HeroComponent />
        
        {/* Features Section */}
        <div id='features' className='bg-base-200 py-16 px-4'>
          <div className='max-w-6xl mx-auto'>
            <h2 className='text-3xl md:text-4xl font-bold text-center mb-12'>How It Works</h2>
            <div className='grid md:grid-cols-3 gap-8'>
              {features.map((feature, index) => (
                <div key={index} className='bg-base-100 p-6 rounded-2xl shadow-lg text-center'>
                  <div className='text-4xl mb-4'>{
                    index === 0 ? '🎮' : index === 1 ? '💬' : '🎯'
                  }</div>
                  <h3 className='text-xl font-bold mb-2'>{feature.title}</h3>
                  <p className='text-base-content/70'>{feature.description}</p>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Available Games Section */}
        <div id='available-games' className='py-16 px-4 bg-base-200'>
          <div className='max-w-6xl mx-auto'>
            <h2 className='text-3xl md:text-4xl font-bold text-center mb-4'>Available Games</h2>
            <p className='text-center text-base-content/70 mb-12 max-w-2xl mx-auto'>Beanbag supports all your favorite games. Find teammates for any title in our growing library.</p>
            <div className='grid grid-cols-4 md:grid-cols-8 gap-6'>
              {availableGames.map((game, index) => (
                <div key={index} className='flex flex-col items-center' title={game.name}>
                  <div className='w-20 h-20 md:w-24 md:h-24 bg-white rounded-xl p-2 shadow-lg flex items-center justify-center hover:scale-125 transition-transform'>
                    <img src={game.logo} alt={game.name} className='w-full h-full object-contain' />
                  </div>
                  {/* <span className='text-xs font-medium text-base-content/70'>{game.short}</span> */}
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* App Screenshots */}
        <div id='screenshots' className='py-16 px-4'>
          <div className='max-w-6xl mx-auto'>
            <h2 className='text-3xl md:text-4xl font-bold text-center mb-4'>Your Next Teammate is One Swipe Away</h2>
            <p className='text-center text-base-content/70 mb-12 max-w-2xl mx-auto'>Beanbag helps gamers find teammates fast. Build your profile and start matching with players who get your vibe.</p>
            <ScreenshotCarousel />
          </div>
        </div>

        {/* CTA Section */}
        <div className='bg-primary text-primary-content py-16 px-4'>
          <div className='max-w-2xl mx-auto text-center'>
            <h2 className='text-white text-3xl md:text-4xl font-bold mb-4'>Download Beanbag Today</h2>
            <p className='text-white text-lg mb-8 opacity-90'>Find your perfect gaming teammates. Swipe, match, and game on.</p>
            <a href='https://apps.apple.com/pt/app/beanbag-chat/id6760129396?l=en-GB' target='_blank' rel='noopener noreferrer'>
              <img 
                src='https://upload.wikimedia.org/wikipedia/commons/3/3c/Download_on_the_App_Store_Badge.svg' 
                alt='Download on App Store' 
                className='h-14 mx-auto hover:opacity-90 transition-opacity'
              />
            </a>
          </div>
        </div>

        <FooterComponent />
    </div>
  );
};

export default Home;
